type BrandLogoProps = {
  compact?: boolean;
  label?: string;
};

export function BrandLogo({ compact = false, label }: BrandLogoProps) {
  return (
    <span className={`brand-mark${compact ? " small" : ""}`}>
      <img
        src="/catermate-logo.png"
        alt={label || ""}
        aria-hidden={label ? undefined : true}
      />
    </span>
  );
}
